import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GlobalHeaderWrapper, HeaderWrapper, StyledDropdown } from "./styles";
import { Wrapper } from "../school-admin-header/styles";
import { Dropdown } from "react-bootstrap";
import profileIcon from "assets/ntat/icons/profile.svg";
import CustomHeaderIcon from "share/custom-header-icon";
import Logo from "assets/ntat/icons/logo.svg";
import HamburgerIcon from "assets/ntat/icons/hamburger.svg";
import { logoutEmployeeRequest } from "../../../../student/Login/actions";
import SidePanel from "share/templates/SidePanel";
import LogoutModal from "share/molecules/logout-modal";
import styled from "styled-components";
import BackIcon from "assets/ntat/icons/chevron-left-black.svg";

const dropdownOptions = [
  {
    id: 5,
    icon: CustomHeaderIcon,
    name: "Logout",
    iconName: "logout",
    type: "logout",
  },
];

const NtatHeader = ({
  showWelcome = false,
  showSupportHandsetHeader = false,
  showHeading = false,
  handleBack = () => {},
  heading = "",
  ...rest
}) => {
  const {
    employeeDetailsReducer: { data },
  } = useSelector((state) => state.studentLogin);
  const dispatch = useDispatch();
  const [employeeName, setEmployeeName] = useState("");
  const [empId, setEmpId] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    (() => {
      try {
        const { first_name, last_name, employee_id } = { ...data };
        if (first_name || last_name) {
          const empName = `${first_name || ""} ${last_name || ""}`;
          setEmployeeName(empName);
        }
        if (employee_id) {
          setEmpId(employee_id);
        }
      } catch (error) {
        setEmployeeName("user");
      }
    })();
  }, [data]);
  const handleDropdown = (type) => {
    if (type === "logout") {
      dispatch(logoutEmployeeRequest());
    }
  };

  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleLogoutModal = () => {
    setShowSidebar(false);
    setShowLogoutModal(true);
  };

  const handleLogout = () => {
    handleDropdown("logout");
    setShowLogoutModal(false);
  };

  return (
    <GlobalHeaderWrapper>
      <HeaderWrapper smallHeader={!showWelcome} {...rest}>
        {showWelcome && (
          <div className="welcome-message">
            <span>Welcome,</span>
            <h3>{employeeName}</h3>
          </div>
        )}
        {!showWelcome && (
          <>
            {!showHeading && (
              <div className="logo-wrapper">
                <img
                  src={HamburgerIcon}
                  alt="menu-icon"
                  className="hamburger-menu"
                  onClick={handleShowSidebar}
                />
                <img src={Logo} alt="NTAT Logo" />
              </div>
            )}
            {showHeading && (
              <div className="header-wrapper">
                <img src={BackIcon} alt="back icon" onClick={handleBack} />
                <h3>{heading}</h3>
                <img src={Logo} alt="NEAP Logo" className="neap-logo" />
              </div>
            )}
          </>
        )}
        {!showHeading && (
          <ProfileComponent
            employeeName={employeeName}
            empId={empId}
            handleDropdown={handleDropdown}
          />
        )}
      </HeaderWrapper>
      {showSupportHandsetHeader && (
        <div className="welcome-message handset-welcome-message">
          <span>Welcome,</span>
          <h3>{employeeName}</h3>
        </div>
      )}
      {showSidebar && (
        <SidePanel
          showSidebar={showSidebar}
          handleClose={handleShowSidebar}
          handleLogout={handleLogoutModal}
        >
          <HandSetProfileWrapper
            employeeName={employeeName}
            empId={empId}
            handleDropdown={handleDropdown}
          />
        </SidePanel>
      )}
      {showLogoutModal && (
        <LogoutModal
          handleCancle={() => setShowLogoutModal(false)}
          handleLogout={handleLogout}
        />
      )}
    </GlobalHeaderWrapper>
  );
};

export default NtatHeader;

const ProfileComponent = ({
  employeeName,
  empId,
  handleDropdown = () => {},
  ...rest
}) => {
  return (
    <ProfileWrapper {...rest}>
      <div className="profile-data">
        <h3 className="name">{employeeName}</h3>
        <span className="admissiion-id">{empId}</span>
      </div>
      <StyledDropdown
        variant=""
        title={
          <div className="profile-picture-wrapper">
            <img src={profileIcon} alt="profile-icon" />
          </div>
        }
      >
        {dropdownOptions.map((field) => (
          <Dropdown.Item
            onClick={() => handleDropdown(field.type)}
            key={field.id}
          >
            <Wrapper>
              <div className="icon">
                <field.icon icon={field.iconName} />
              </div>
              <p className="item-name">{field.name}</p>
            </Wrapper>
          </Dropdown.Item>
        ))}
      </StyledDropdown>
    </ProfileWrapper>
  );
};

const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  .profile-data {
    color: #2b2928;
    display: flex;
    flex-direction: column;
    gap: 4px;
    .name {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.374px;
      color: #2b2928;
    }
    .admissiion-id {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #2b2928;
      text-align: right;
    }
  }
  .profile-picture-wrapper {
    width: 48px;
    height: 48px;
    background: linear-gradient(180deg, #fdd8a4 0%, #f0c17e 100%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.4px solid;
    border-image-source: linear-gradient(
      180deg,
      #ffffff 0.96%,
      rgba(255, 255, 255, 0) 98.96%
    );
  }

  @media screen and (max-width: 1240px) {
    .profile-data {
      display: none;
    }
    .profile-picture-wrapper {
      height: 40px;
      width: 40px;
    }
  }
  .sidebar-profile-wrapper {
    margin-bottom: 32px;
    .profile-data {
      display: flex;
      align-items: flex-start;
    }
  }
`;
const HandSetProfileWrapper = styled(ProfileComponent)`
  flex-direction: row-reverse;
  justify-content: flex-end;
  margin-bottom: 32px;
  .profile-data {
    display: flex;
    align-items: flex-start;
  }
`;
